import Footer from "./components/footer/footer";
import Header from "./components/header/header";
import Schedule from "./components/schedule/schedule";
import Statistics from "./components/statistics/statistics";
import Testimonials from "./components/testimonials/testimonials";

function App() {
  return (
    <div>
      <Header />
      <Statistics />
      <Schedule />
      <Testimonials />
      <Footer />
      {/* <Button
        type="primary"
        className="flex items-center font-bold uppercase"
        shape="round"
        icon={<PlusOutlined className="font-bold text-white" />}
        onClick={action}
      >
        {text}
      </Button> */}


    </div>
  );
}

export default App;
